import {
    AccessTokens,
    AuthSuiteDataLocalStorageService,
    AuthSuiteRequest,
} from '@cbsi-cbscom/auth-suite-sdk';

export default class AuthSuiteLocalDataStorageService {
    constructor() {
        this.localDataStorageService = new AuthSuiteDataLocalStorageService();
    }

    /**
     * Returns access tokens
     *
     * @returns {Promise<AccessTokens>} - - Promise of AccessTokens response
     */
    getAccessTokens() {
        return this.localDataStorageService.getAccessTokens();
    }

    /**
     * Returns storage data
     *
     * @returns {Promise<AuthSuiteRequest>} - - Promise of AuthSuiteRequest response
     */
    getAuthSuiteRequestData() {
        return this.localDataStorageService.getAuthSuiteRequestData();
    }

    /**
     * Returns clientID
     *
     * @returns {string} - - client id response
     */
    getClientId() {
        return this.localDataStorageService.getClientId();
    }

    /**
     * Returns clientID
     *
     * @returns {string} - - client id response
     */
    getDeviceRefreshToken() {
        return this.localDataStorageService.getDeviceRefreshToken();
    }

    /**
     * Returns clientID
     *
     * @returns {string} - - client id response
     */
    getApplicationAccessToken() {
        return this.localDataStorageService.getApplicationAccessToken();
    }
}
